module.exports = __webpack_public_path__ + "img/hil-logo-text-white.c3f1a6b1.png";